// Outbound module:

// {{{ FileUploadBox

GW.define('FileUploadBox', 'GW.Component', {
	uploadButtonText: _('Nahrát soubor'),
	sizeLimit: 20,
	fileType: '.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'drop-zone',
			children: [{
				ref: 'uploadButton',
				nodeName: 'button',
				type: 'button',
				className: 'secondary icon-left',
				children: [Utils.useIcon('upload'), this.uploadButtonText],
				'on:click': async ev => {
					ev.preventDefault();

					let file = await Uploads.fileSelect(this.fileType);
					if (file) {
						this.processFile(file);
					}
				},
			}, {
				className: 'dnd-note',
				textContent: _('Nebo soubor přetáhněte sem'),
			}],
			'on:dropfiles': ev => {
				let files = ev.detail.files;
				if (files.length != 1) {
					throw new Error(_('Přetáhnout lze pouze jeden soubor'));
				}

				this.processFile(files[0]);
			},
		}, this);
	},

	processFile(file) {
		if (file.size > this.sizeLimit * 1024 * 1024) {
			throw new Error(_('Lze nahrát pouze soubor do velikosti {size} MiB').replace('{size}', this.sizeLimit));
		}

		this.fire('fileselect', file);
	},

	setDisabled(disabled) {
		this.disabled = !!disabled;

		this.el.classList.toggle('drop-zone', !this.disabled);
		this.uploadButton.disabled = this.disabled;
	},
});

// }}}
// {{{ Outbound.NewCampaignDialog

GW.define('Outbound.NewCampaignDialog', 'Main.FormDialog', {
	title: _('Nová kampaň'),

	renderFormFields() {
		let me = this;

		return [{
			xtype: 'TextField',
			name: 'name',
			label: _('Název'),
		}, {
			xtype: 'TextareaField',
			name: 'description',
			label: _('Popis'),
			optional: true,
		}, {
			ref: 'groupField',
			xtype: 'SelectField',
			name: 'group_id',
			label: _('Skupina'),
			placeholder: _('Všechny'),
			optional: true,
			options: [
				{
					text: _('Všechny'),
					value: null,
				},
				...Application.session.user.groups.map(g => ({
					text: g.name,
					value: g.id,
				})),
			],
			'on:change': c => {
				this.queueField.setValue();
			},
		}, {
			ref: 'queueField',
			xtype: 'SelectField',
			name: 'prefix_queue',
			label: _('Fronta skrze kterou volat'),
			filterable: true,
			placeholder: _('Žádná'),
			optional: true,
			transformOption(o) {
				return {
					value: o.queue,
					text: o.queue + (o.name ? ' (' + o.name + ')' : ''),
				};
			},
			async getOptions({signal}) {
				let queues = await REST.GET('queues', null, {
					signal,
					activeUserGroup: me.groupField.getValue(),
				});

				return [{
					value: null,
					text: _('Žádná'),
				}, ...queues.map(e => {
					return {
						value: e.queue,
						text: e.queue + (e.name ? ' (' + e.name + ')' : ''),
					};
				})];
			},

			visibleWhen: data => data.group_id,
		}, {
			ref: 'contactsUpload',
			xtype: 'FileUploadBox',
			uploadButtonText: _('Nahrát soubor (.XLSX)'),
			'on:fileselect': async (c, file) => {
				try {
					c.setDisabled(true);
					await this.importContacts(file);
				} finally {
					c.setDisabled(false);
				}
			},
		}, {
			ref: 'fileEl',
			className: 'file-handle',
		}];
	},

	showContacts(list) {
		new Main.Dialog({
			title: _('Kontakty k importu'),

			'after:initComponent'() {
				this.el.classList.add('fullscreen');
				this.bodyEl.gwCreateChild({
					xtype: 'SmartTable',
					extraClass: 'outbound-cases-import-smart-table',
					getColumns() {
						return [{
							id: 'name',
							name: _c('Jméno', 'campaign-case-export'),
						}, {
							id: 'company',
							name: _c('Firma', 'campaign-case-export'),
						}, {
							id: 'phone',
							name: _c('Telefon', 'campaign-case-export'),
						}, {
							id: 'note',
							name: _c('Poznámka', 'campaign-case-export'),
							formatCell(td, v, row) {
								v = (v || '').trim();

								td.textContent = v.replace(/\r?\n/g, ' ⏎ ');
								td.title = v;
							},
						}, {
							id: 'time_range_start',
							name: _c('Časový slot od', 'campaign-case-export'),
							format: 'time_short_utc',
						}, {
							id: 'time_range_end',
							name: _c('Časový slot do', 'campaign-case-export'),
							format: 'time_short_utc',
						}, {
							id: 'url',
							name: _c('Odkaz', 'campaign-case-export'),
						}];
					},
					rows: list,
				});
			},
		});
	},

	'wrap:renderFormButtons'(fn) {
		return [{
			ref: 'showButton',
			nodeName: 'button',
			type: 'button',
			className: 'secondary',
			disabled: true,
			textContent: _('Zobrazit kontakty'),
			'on:click': ev => {
				this.showContacts(this.contacts || []);
			},
		}, ...fn()];
	},

	async onSave(data) {
		data.contacts = this.contacts || [];

		await REST.POST('outbound/campaigns', data);

		Application.notify({
			kind: 'success',
			text: _('Kampaň byla založena. Naleznete ji v záložce "Neaktivní."'),
			priority: 5,
			timeout: 3000,
		});
	},

	get_i18n_column_index_map(header, cols, ctx) {
		let langs = Object.keys(i18n.langs);
		let map = new Map;
		let missing = [];

		for (let c of cols) {
			let indexes = langs.map(l => header.findIndex(c_title => c_title == _lc(l, c.title, ctx)));
			let index = indexes.find(i => i >= 0);

			if (index != null) {
				map.set(c.id, index);
			} else {
				if (!c.optional) {
					missing.push({id: c.id, title: _c(c.title, ctx)});
				}
			}
		}

		return [map, missing];
	},

	async importContacts(file) {
		let res = await Uploads.uploadFile('import/xlsx', file, {
			headers: {
				'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			},
		});

		if (!(res[0] instanceof Array)) {
			throw new Error(_('V prvním řádku XLSX souboru musí být názvy sloupců: Jméno, Firma, Telefon'));
		}

		function get_import_columns() {
			let _c = _ => _;

			const to_seconds = val => {
				if (val == null) {
					return null;
				}

				/*
				 * XLSX importer passes this for cells that have
				 * time type, and are not just text. val is then
				 * a decimal number 0-1 range that shows time of
				 * day as fraction of the day.
				 */
				if (typeof val == 'number') {
					/*
					 * Math.ceil is needed, otherwise exported
					 * contacts list may not be interpreted
					 * correctly and rounded to incorrect
					 * time.
					 */
					return Math.ceil(val * 24 * 60 * 60);
				}

				/*
				 * Text that may look like a time in format
				 * HH:MM(:SS).
				 */
				let m = String(val).match(/^\s*(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?\s*$/);
				if (m) {
					return m[1] * 3600 + m[2] * 60 + (m[3] ? Number(m[3]) : 0);
				}

				return null;
			};

			return [{
				id: 'name',
				title: _c('Jméno', 'campaign-case-export'),
			}, {
				id: 'company',
				title: _c('Firma', 'campaign-case-export'),
			}, {
				id: 'phone',
				title: _c('Telefon', 'campaign-case-export'),
			}, {
				id: 'note',
				title: _c('Poznámka', 'campaign-case-export'),
				optional: true,
			}, {
				id: 'time_range_start',
				title: _c('Časový slot od', 'campaign-case-export'),
				convert: to_seconds,
				optional: true,
			}, {
				id: 'time_range_end',
				title: _c('Časový slot do', 'campaign-case-export'),
				convert: to_seconds,
				optional: true,
			}, {
				id: 'url',
				title: _c('Odkaz', 'campaign-case-export'),
				optional: true,
			}];
		}

		let columns = get_import_columns();
		let [colMap, missing] = this.get_i18n_column_index_map(res[0], columns, 'campaign-case-export');

		if (missing.length > 0) {
			throw new Error(_('V prvním řádku XLSX souboru chybí názvy sloupců: {cols}')
				.replace('{cols}', missing.map(c => c.title).join(', ')));
		}

		let contacts = res.slice(1).map(r => Object.fromEntries(columns.map(col => {
			let val = r[colMap.get(col.id)];
			return [col.id, col.convert ? col.convert(val) : val];
		}))).filter(c => c.phone != null);

		this.contacts = contacts;
		this.showButton.disabled = this.contacts.length == 0;

		this.fileEl.gwReplaceChildren([{
			className: 'name',
			textContent: file.name,
		}, {
			nodeName: 'button',
			type: 'button',
			className: 'file-handle-button',
			'on:click': ev => {
				this.fileEl.textContent = '';
				this.contacts = [];
				this.showButton.disabled = this.contacts.length == 0;
			},
		}]);
	},
});

// }}}
// {{{ Outbound.EditCampaignDialog

GW.define('Outbound.EditCampaignDialog', 'Main.FormDialog', {
	title: _('Upravit kampaň'),
	data: null,

	'after:initComponent'() {
		this.setFormFieldsData(this.data);
	},

	renderFormFields() {
		let me = this;

		return [{
			xtype: 'TextField',
			name: 'name',
			label: _('Název'),
		}, {
			xtype: 'TextareaField',
			name: 'description',
			label: _('Popis'),
			optional: true,
		}, {
			ref: 'groupField',
			xtype: 'SelectField',
			name: 'group_id',
			label: _('Skupina'),
			placeholder: _('Všechny'),
			optional: true,
			'on:change': c => {
				this.queueField.setValue();
			},
			options: [
				{
					text: _('Všechny'),
					value: null,
				},
				...Application.session.user.groups.map(g => ({
					text: g.name,
					value: g.id,
				})),	
			],
		}, {
			ref: 'queueField',
			xtype: 'SelectField',
			name: 'prefix_queue',
			label: _('Fronta skrze kterou volat'),
			filterable: true,
			placeholder: _('Žádná'),
			optional: true,
			transformOption(o) {
				return {
					value: o.queue,
					text: o.queue + (o.name ? ' (' + o.name + ')' : ''),
				};
			},
			async getOptions({signal}) {
				let queues = await REST.GET('queues', null, {
					signal,
					activeUserGroup: me.groupField.getValue(),
				});

				return [{
					value: null,
					text: _('Žádná'),
				}, ...queues.map(e => {
					return {
						value: e.queue,
						text: e.queue + (e.name ? ' (' + e.name + ')' : ''),
					};
				})];
			},

			visibleWhen: data => data.group_id,
		}];
	},

	async onSave(data) {
		data.prefix_queue = data.prefix_queue || null;

		return await REST.PUT('outbound/campaigns/' + this.data.id, data);
	},
});

// }}}
// {{{ Outbound.CampaignDetailDialog

GW.define('Outbound.CampaignDetailDialog', 'Main.Dialog', {
	
	campaignId: null,

	'after:initComponent'() {
		let me = this;

		this.el.classList.add('fullscreen');

		this.searchEl = this.headerCenterCt.gwCreateChild({
			nodeName: 'input',
			type: 'search',
			placeholder: _('Hledat kontakt'),
			className: 'small',
			autofocus: true,
			'on:input': ev => {
				this.refresh();
			},
		});

		this.bodyEl.gwReplaceChildren([{
			className: 'controls',
			children: [{
				nodeName: 'button',
				className: 'secondary small',
				type: 'button',
				textContent: _('Exportovat XLSX'),
				'on:click': () => {
					location.href = API_BASE + 'outbound/campaigns/' + encodeURIComponent(this.campaignId) + '/cases/export/xlsx';
				}
			}],
		}, {
			ref: 'table',
			xtype: 'SmartTable',
			extraClass: 'outbound-cases-smart-table',
			getColumns() {
				return [{
					id: 'contact_name',
					name: _c('Jméno', 'campaign-case-export'),
					formatCell(td, v, row) {
						td.textContent = row.contact_name || row.contact_company ? v : row.contact_name_linked;
					},
				}, {
					id: 'contact_company',
					name: _c('Firma', 'campaign-case-export'),
					formatCell(td, v, row) {
						td.textContent = row.contact_name || row.contact_company ? v : row.contact_company_linked;
					},
				}, {
					id: 'contact_phone',
					name: _c('Telefon', 'campaign-case-export'),
				}, {
					id: 'contact_note',
					name: _c('Poznámka', 'campaign-case-export'),
					formatCell(td, v, row) {
						v = (v || '').trim();

						td.textContent = v.replace(/\r?\n/g, ' ⏎ ');
						td.title = v;
					},
				}, {
					id: 'status',
					name: _('Stav'),
					format: 'campaign_case_status',
				}, {
					id: 'activated',
					name: _('Čas zahájení'),
					format: 'datetime',
				}, {
					id: 'last_agent_name',
					name: _('Vyřizuje'),
				}, {
					id: 'last_agent_exten',
					name: _('Linka'),
				}, {
					id: 'attempts',
					name: _('Pokusů'),
				}, {
					id: 'closing_agent_name',
					name: _('Vyřídil'),
				}, {
					id: 'closing_agent_exten',
					name: _('Linka'),
				}, {
					id: 'closed',
					name: _('Čas vyřízení'),
					format: 'datetime',
				}, {
					id: 'contact_time_range_start',
					name: _c('Časový slot od', 'campaign-case-export'),
					format: 'time_short_utc',
				}, {
					id: 'contact_time_range_end',
					name: _c('Časový slot do', 'campaign-case-export'),
					format: 'time_short_utc',
				}, {
					id: 'url',
					name: _c('Odkaz', 'campaign-case-export'),
					formatCell(td, v, row) {
						if (v != null && String(v).match(/^[a-z0-9.+-]{1,30}:/i)) {
							td.gwCreateChild({
								nodeName: 'a',
								href: v,
								target: '_blank',
								textContent: _('Otevřít'),
							});
						} else if (v != null) {
							td.textContent = v;
						}
					},
				}, {
					id: 'ctl',
					name: _('Poznámky'),
					formatCell(td, v, row) {
						td.gwCreateChild({
							nodeName: 'button',
							type: 'button',
							className: 'secondary notes small' + (row.has_notes ? ' filled' : ''),
							'attr:data-notesbtnfor': row.id,
							'on:click': ev => {
								ev.preventDefault();
								me.showNotesDialog(ev, row);
							},
						});
					},
				}];
			},
			renderRow(tr, row) {
				tr.classList.toggle('linked-contact', !(row.contact_name || row.contact_company)
					&& !!(row.contact_company_linked || row.contact_name_linked));
			},
		}], this);

		this.refresh();
	},

	showNotesDialog(ev, data) {
		let me = this;

		new Main.NotesDialog({
			async onSave(text) {
				await REST.POST('outbound/cases/' + encodeURIComponent(data.id) + '/comments', {
					text,
				});

				data.has_notes = true;

				let btn = me.el.querySelector('[data-notesbtnfor="' + data.id + '"]');
				if (btn) {
					btn.classList.add('filled');
				}
			},

			loadData(signal) {
				return REST.GET('outbound/cases/' + encodeURIComponent(data.id) + '/comments', null, {signal});
			},
		});
	},

	refresh() {
		let match = TextUtils.createMatchAll(this.searchEl.value.trim());
		let cases = this.cases.filter(c => match([c.contact_name || '', c.contact_company || '', c.contact_phone || ''].join(' ')));

		this.table.setData(cases);
	},
});

// }}}
// {{{ Outbound.CampaignsScreen

GW.define('Outbound.CampaignsScreen', 'Main.Screen', {
	title: _('Outbound'),
	titleIcon: 'phone-outgoing',

	'after:initComponent'() {
		let me = this;

		this.status = 'active';

		this.bodyEl.gwReplaceChildren([{
			className: 'panel-container',
			children: [{
				nodeName: 'form',
				'on:submit': ev => {
					ev.preventDefault();
					this.reload();
				},
				className: 'toolbar',
				children: [{
					ref: 'statusSelector',
					xtype: 'Widgets.ButtonSwitcher',
					items: [{
						id: 'active',
						title: _('Aktivní'),
						query: {
							status: 'active',
						},
					}, {
						id: 'new',
						title: _('Neaktivní'),
						query: {
							status: 'new',
						},
					}, {
						id: 'closed',
						title: _('Archivované'),
						query: {
							status: 'closed',
						},
					}],
					'on:beforeselect': (c, i) => {
						Application.route({
							paramsFn: params => {
								params.set('status', i.id);
								return params;
							},
						});
					},
				}, {
					ref: 'searchEl',
					nodeName: 'input',
					type: 'search',
					placeholder: _('Hledat kampaň'),
					className: 'small',
					autofocus: !Application.isMobileUI(),
					'on:input': ev => {
						Application.route({
							paramsFn: params => {
								params.set('q', ev.target.value);
								return params;
							},
						});
					},
				}, {
					nodeName: 'button',
					className: 'primary small',
					type: 'button',
					children: [_('Obnovit')],
					'on:click': ev => {
						this.reload();
					},
				}, {
					nodeName: 'button',
					className: 'secondary small',
					type: 'button',
					children: [_('Stáhnout vzor XLSX')],
					'on:click': ev => {
						location.href = API_BASE + 'outbound/campaigns/cases/export/xlsx';
					},
				}, {
					nodeName: 'button',
					className: 'secondary small icon-left',
					type: 'button',
					children: [Utils.useIcon('plus'), _('Přidat kampaň')],
					'on:click': ev => {
						ev.preventDefault();
						this.createEntry();
					},
				}],
			}, {
				ref: 'table',
				xtype: 'FilterableSmartTable',
				extraClass: 'no-padding cdr-smart-table',
				getColumns() {
					return [{
						sortable: true,
						id: 'name',
						name: _('Jméno kampaně'),
					}, {
						sortable: true,
						id: 'created',
						name: _('Čas založení'),
						format: 'datetime',
					}, {
						sortable: true,
						id: 'start_ts',
						name: _('Čas zahájení'),
						format: 'datetime',
					}, {
						sortable: true,
						id: 'end_ts',
						name: _('Čas ukončení'),
						format: 'datetime',
					}, {
						sortable: {type: 'numeric'},
						id: 'case_count',
						name: _('Celkový počet čísel'),
					}, {
						sortable: {type: 'numeric'},
						id: 'active_case_count',
						name: _('Počet rozvolaných čísel'),
					}, {
						sortable: {type: 'numeric'},
						id: 'active_case_rate',
						name: _('Rozvolanost'),
						format: 'percent',
					}, {
						sortable: {type: 'numeric'},
						id: 'closed_case_count',
						name: _('Počet dokončených případů'),
					}, {
						sortable: {type: 'numeric'},
						id: 'closed_case_rate',
						name: _('Dokončenost'),
						format: 'percent',
					}, {
						id: 'description',
						name: _('Popis'),
						formatCell(td, v, row) {
							td.textContent = v;
							td.title = v;
						},
					}, {
						id: 'group_name',
						name: _('Skupina'),
						formatCell(td, v, row) {
							if (v == null) {
								td.gwReplaceChildren([{
									nodeName: 'em',
									textContent: _('Všechny'),
								}])
							} else {
								td.textContent = v;
							}
						},
					}, {
						id: 'ctl',
						formatCell(td, v, row) {
							td.gwCreateChild({
								nodeName: 'a',
								href: '#',
								className: 'menu',
								'on:click': ev => {
									ev.preventDefault();
									me.showEntryMenu(ev, row);
								},
							});
						},
					}];
				},
			}],
		}], this);

		setTimeout(() => {
			// help firefox
			let autofocusInputEl = this.el.querySelector('[autofocus]');
			if (autofocusInputEl) {
				autofocusInputEl.focus();
			}
		}, 0);
	},

	createEntry() {
		new Outbound.NewCampaignDialog({
			'on:aftersave': (c, data) => {
				this.reload();
			},
		});
	},

	editEntry(data) {
		let dlg = new Outbound.EditCampaignDialog({
			data,

			'on:aftersave': (c, data) => {
				this.reload();
			},
		});
	},

	deleteEntry(data) {
		let me = this;

		new Main.ConfirmDialog({
			title: _('Opravdu chcete smazat kampaň "{name}"?').replace('{name}', data.name),
			subtitle: _('Tato akce nelze vzít zpět.'),

			async onSave() {
				await REST.DELETE('outbound/campaigns/' + data.id);
				me.reload();
			},
		});
	},

	async activateEntry(data) {
		await REST.POST('outbound/campaigns/' + encodeURIComponent(data.id) + '/activate', {});
		this.reload();
	},

	async archiveEntry(data) {
		await REST.POST('outbound/campaigns/' + encodeURIComponent(data.id) + '/close', {});
		this.reload();
	},

	async renewEntry(data) {
		await REST.POST('outbound/campaigns/' + encodeURIComponent(data.id) + '/renew', {});
		this.reload();
	},

	async showEntryDetail(data) {
		let cases = await REST.GET('outbound/campaigns/' + encodeURIComponent(data.id) + '/cases');

		new Outbound.CampaignDetailDialog({
			title: data.name || _('Detail kampaně'),
			campaignId: data.id,
			cases,
		});
	},

	showEntryMenu(ev, data) {
		let popup = new PopupMenu({
			options: [{
				text: _('Detail kampaně'),
				iconName: 'document',
				handle: this.showEntryDetail.bind(this, data),
			}, {
				hidden: data.status == 'closed',
				text: _('Upravit kampaň'),
				iconName: 'pencil',
				handle: this.editEntry.bind(this, data),
			}, {
				hidden: data.status != 'new',
				text: _('Aktivovat kampaň'),
				iconName: 'play',
				handle: this.activateEntry.bind(this, data),
			}, {
				hidden: data.status != 'closed',
				text: _('Vrátit do neaktivních'),
				iconName: 'fi-corner-up-left',
				handle: this.renewEntry.bind(this, data),
			}, {
				hidden: data.status != 'active',
				text: _('Deaktivovat kampaň'),
				iconName: 'pause',
				handle: this.renewEntry.bind(this, data),
			}, {
				hidden: data.status == 'closed',
				text: _('Archivovat kampaň'),
				iconName: 'archive',
				handle: this.archiveEntry.bind(this, data),
			}],
		});

		PopupManager.show(popup, {
			anchorEl: ev.target.closest('.menu'),
			forceAxis: 'vertical',
			preferReadingOrder: true,
		});
	},

	reload() {
		Utils.clearCache(this);
		this.applyParams(new URLSearchParams(location.search));
	},

	async applyParams(params) {
		// get status that should be active
		let statuses = this.statusSelector.getItems();
		let status = statuses.find(s => s.id == params.get('status'));
		if (!status) {
			status = statuses[0];
		}

		this.status = status.id;

		let q = params.get('q') || '';
		if (this.searchEl.value != q) {
			this.searchEl.value = q;
		}

		this.statusSelector.setSelected(status.id);

		let signal = Utils.abortAndRetry(this, 'reload');
		let [campaigns, changed] = await Utils.cache(this, 'campaigns', 60000, REST.GET, 'outbound/campaigns', {
			...status.query,
		}, {signal});
		if (changed || this.lastQuery != q) {
			this.lastQuery = q;
			
			let match = TextUtils.createMatchAll(q);

			this.table.setData(campaigns.filter(c => match([c.name, c.description || '', c.group_name || ''].join(' '))));
		}
		//this.table.selectRow(row => row.id === contact);
	},
});

// }}}
// {{{ Routes

Application.addRoutes([{
	group: 'auth',
	module: 'outbound',
	path: APP_BASE + 'outbound',
	async handler({params}) {
		let c = Application.show({
			id: 'outbound.campaigns',
			xtype: 'Outbound.CampaignsScreen',
		});

		c.applyParams(params);
	}    
}]);

// }}}

Application.registerModule({
	id: 'outbound',
	title: _('Outbound'),
	tagline: _('Správa odchozích kampaní'),
	icon: 'phone-outgoing',
	href: APP_BASE + 'outbound',
});
